module.exports = __webpack_public_path__ + "assets/1158e98cace59bfcc491cf0d5f9be7c2.mp4";